import { hciJapaneseFontFamily, hciChineseFontFamily, avFontFamily } from '@/assets/styles/variables.module.scss';

function applyFont(locale: string) {
  const fontFaces = {
    ja: hciJapaneseFontFamily,
    zh: hciChineseFontFamily,
  };

  const font = fontFaces[locale] ? fontFaces[locale] : avFontFamily;
  document.documentElement.style.setProperty('--ui-kit-font', font);
}

export default applyFont;
